import { GenericModalCombinedProps } from './types';

const usePresenter = (props: GenericModalCombinedProps): GenericModalCombinedProps => {
  return props;
};

export default usePresenter;
